module.exports = __webpack_public_path__ + "static/img/90pw.80ee377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/90pw.jpg
// module id = lZTI
// module chunks = 1